import axios from 'axios';

import routes from 'app/routes';

export default {
  load: (dispatch, resourceType, resourceId) => {
    dispatch({ type: 'LOAD', notes: null });

    if (resourceType && resourceId) {
      const params = {
        resource_note: {
          resource_type: resourceType,
          resource_id: resourceId,
        },
      };

      axios
        .get(routes.api.resource_notes.index, { params })
        .then((response) => {
          dispatch({ type: 'LOAD', notes: response.data.data });
        });
    }
  },

  create: (dispatch, resourceType, resourceId, values, successCallback, errorCallback) => {
    if (resourceType && resourceId) {
      const params = {
        resource_note: {
          resource_type: resourceType,
          resource_id: resourceId,
          body: values.body,
          date: values.date,
        },
      };

      axios
        .post(routes.api.resource_notes.create, params)
        .then((response) => {
          dispatch({ type: 'CREATE', note: response.data.data });
          successCallback();
        })
        .catch((error) => {
          errorCallback(error.response.data);
        });
    }
  },

  update: (dispatch, resourceType, resourceId, noteId, values, successCallback, errorCallback) => {
    if (resourceType && resourceId) {
      const params = {
        resource_note: {
          resource_type: resourceType,
          resource_id: resourceId,
          body: values.body,
          date: values.date,
        },
      };

      axios
        .patch(routes.api.resource_notes.update(noteId), params)
        .then((response) => {
          dispatch({ type: 'UPDATE', note: response.data.data });
          successCallback();
        })
        .catch((error) => {
          errorCallback(error.response.data);
        });
    }
  },

  destroy: (dispatch, resourceType, resourceId, noteId) => {
    if (resourceType && resourceId) {
      const params = {
        resource_note: {
          resource_type: resourceType,
          resource_id: resourceId,
        },
      };

      axios
        .delete(routes.api.resource_notes.destroy(noteId), { params })
        .then((_response) => {
          dispatch({ type: 'DESTROY', noteId });
        });
    }
  },
};
